import { getActiveTokens } from "@/shared/auth/helper/getActiveTokens.helper";
import { DEV_JWT_KEY } from "@/shared/helper/constants.helper";
import { isDevelopment } from "@/shared/helper/environment.helper";

export const getJwt = async () => {
  const tokens = await getActiveTokens();

  // There are no auth tokens stored in the cookie in development mode, so we use the stored test user token from the local storage
  if (isDevelopment && !tokens) {
    return localStorage.getItem(DEV_JWT_KEY);
  }

  return tokens?.idToken;
};
